import { GET } from './api';

export const PbToken = async () => {
  return await GET(`/webhook/pbtoken`, true);
};
